import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "InventoryManagement"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 18H12.75V19.5H3C2.17192 19.4992 1.50083 18.8281 1.5 18V7.5C1.50083 6.67192 2.17192 6.00083 3 6H7.5V3C7.50083 2.17192 8.17192 1.50083 9 1.5H15C15.8281 1.50083 16.4992 2.17192 16.5 3V6H21C21.8281 6.00083 22.4992 6.67192 22.5 7.5V11.25H21V7.5H3V18ZM15 3H9V6H15V3ZM14.25 18H17.25V21H14.25V18ZM14.25 12.75H17.25V15.75H14.25V12.75ZM22.5 15.75V12.75H19.5V15.75H22.5ZM22.5 18H19.5V21H22.5V18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/InventoryManagement.vue"]]);
